import ClientUserTokenItem from "./ClientUserTokenItem";
import useClientUserExternalTokens from "@/features/privateCompanies/hooks/users/useClientUserExternalTokens";
import { useParams } from "react-router-dom";
import Skeleton from "@/common/components/Skeleton";
import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import CreateClientUserTokenModal from "./CreateClientUserTokenModal";
import { ClientUserExternalTokensData } from "@/features/privateCompanies/types/users/clientUserExternalTokens.type";
import useUserPermissions from "@/common/hooks/useUserPermissions";

const ClientUserTokens = () => {
  const { id } = useParams();

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();

  const {
    data: clientUserExtenalTokens,
    meta: clientUserExtenalTokensMeta,
    isPending: clientUserExtenalTokensIsPending,
  } = useClientUserExternalTokens<ClientUserExternalTokensData>({
    filters: {
      clientUserId: id,
    },
  });

  if (!isUserPermissionsPending && !hasUserPermission("Admin::Client::UserExternalTokens::Filter")) {
    return null;
  }

  return (
    <div className="w-full rounded-sm p-4 bg-white-100 flex flex-col gap-4">
      <div className="flex w-full items-center justify-between">
        <p>
          Tokens
        </p>

        <div className="flex items-center gap-2">
          <CreateClientUserTokenModal clientUserId={id} />
        </div>
      </div>

      {clientUserExtenalTokensIsPending && new Array(2).fill(null).map((_, i) => (
        <Skeleton key={`token_skeleton_${i}`} height={56} />
      ))}

      {!clientUserExtenalTokensIsPending && clientUserExtenalTokensMeta.total === 0 && (
        <EmptyDataMessage
          className="h-64 overflow-hidden -mt-8"
          imageHeight={180}
          message="Este usuário não possui nenhum token"
        />
      )}

      {!clientUserExtenalTokensIsPending && clientUserExtenalTokensMeta.total > 0 && (
        clientUserExtenalTokens.map((token, index) => (
          <ClientUserTokenItem
            key={token.id}
            token={token}
            displayIndex={clientUserExtenalTokens.length - index}
          />
        ))
      )}
    </div>
  );
}

export default ClientUserTokens;
